import { browserTracingIntegration, type BrowserOptions } from "@sentry/react";
import { beforeSendTransaction } from "./beforeSendTransaction";
import { shouldCreateSpanForRequest } from "./shouldCreateSpanForRequest";
import { SHARED_IGNORE_ERRORS } from "./ignoreErrors";
import { beforeSend } from "./beforeSend";

export interface SentryConfigOptions {
  dsn: string;
  environment: string;
  enabled: boolean;
  release: string;
  tracesSampleRate?: number;
  ignoreErrors?: (string | RegExp)[];
  integrations?: BrowserOptions["integrations"];
  enableLogs?: boolean;
  initialScope?: BrowserOptions["initialScope"];
}

export const createSentryConfig = ({
  dsn,
  environment,
  enabled,
  release,
  tracesSampleRate = 0.05,
  ignoreErrors = [],
  integrations,
  enableLogs,
  initialScope
}: SentryConfigOptions): BrowserOptions => ({
  dsn,
  environment,
  enabled,
  release,
  integrations: integrations ?? [
    browserTracingIntegration({
      shouldCreateSpanForRequest,
      enableLongTask: false,
      enableInp: false,
      enableHTTPTimings: false
    })
  ],
  tracesSampleRate,
  beforeSend,
  beforeSendTransaction,
  maxBreadcrumbs: 150,
  ignoreErrors: [...SHARED_IGNORE_ERRORS, ...ignoreErrors],
  ...(enableLogs !== undefined ? { enableLogs } : {}),
  ...(initialScope !== undefined ? { initialScope } : {})
});
